import { render, staticRenderFns } from "./WhatsappBroadcastCreated.vue?vue&type=template&id=19bf109c&scoped=true"
import script from "./WhatsappBroadcastCreated.vue?vue&type=script&lang=js"
export * from "./WhatsappBroadcastCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf109c",
  null
  
)

export default component.exports